<template>
  <div id="manage">
    <div class="content">
        <div class="title">更新日志</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left addClass" @click="addRecruit">新增更新</div>
                </div>
                <div class="bottom" >
                    <Timeline>
                        <Timeline-item v-for="item in data6" :key="keys">
                            <p class="time">{{ item.title }}</p>
                            <p class="content" v-html="item.content" style="margin:15px 0;">{{ item.content }}</p>
                            <p class="time" style="color:#999">{{ item.updated_at }}</p>
                        </Timeline-item>
                    </Timeline>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'updatelog',
        data () {
            return {
                loading:false,                
                data6: [],
                alertShow:false,
                valm:0,
                num:0,
                tabId:0,
                maxnum:''
            }
        },
        methods:{
            search(index){
                let _this=this;
                _this.$axios.post('getupdateloglist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.data6=res.data.data;
                        console.log(_this.data6);
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            addRecruit(){
                let _this=this;
                localStorage.removeItem("luder");
                this.$router.push({
                    path:'/manager/peizhi/updateLog/newLog',
                    query:{}
                })
            },
        },
        created(){
            let _this=this; 
            let luder=JSON.parse(localStorage.getItem("luder"));
            if(luder!=null){
                _this.search(0)
            }else{
                _this.search(0)
            }
        }
    }
</script>

<style scoped>
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .time{
        font-size: 14px;
        font-weight: bold;
    }
    .content{
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        padding: 20px;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/peizhi/updateLog.vue